import { Injectable } from '@angular/core';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserData {
  constructor(private storage: StorageService) {}

  async setUser(user: object) {
    return await this.storage.set('user', user).toPromise();
  }

  async getUser() {
    return await this.storage.get('user').toPromise();
  }

  async getName() {
    return (await this.storage.get('user').toPromise())?.fullname;
  }

  async getRole() {
    return (await this.storage.get('user').toPromise())?.role;
  }

  async getAccessToken() {
    return (await this.storage.get('user').toPromise())?.accessToken;
  }

  async setAccessToken(accessToken) {
    let user = await this.getUser();
    user.accessToken = accessToken;
    const updatedUser = await this.setUser(user);
    return updatedUser.accessToken;
  }

  async remove() {
    return await this.storage.remove('user').toPromise();
  }
}
